export default {
  install(Vue, options) {
    Vue.prototype.$_ = (code, payload) => {

      
        let lang = options.store.getters['application/get_application_translation'];

        if(payload !== undefined) {

          let test = '';

          Object.entries(payload).map(res => {
            if(test !== '') {
              test = test.replace('%%'+res[0]+'%%', res[1]);
            } else {
              test = lang[code].replace('%%'+res[0]+'%%', res[1]);
            }
          })
          return test
        }
        return lang[code];
      }
  }
};
